/* globals PropTypes */

import WizardNestedFields from './wizard_nested_fields.js'
import DropzoneAttachments from 'components/DropzoneAttachments'
import SkillsTree from 'components/skills/SkillsTree'
import PhotoWithCropper from 'components/PhotoWithCropper'
import INPUT_TYPE_MAP from './input_type_map'
import cn from 'classnames'

export default class WizardStep extends React.Component {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate () {
    $(document).trigger('resize')
  }

  render () {
    const {
      name, settings, candidate, photo_attributes: photoAttributes, default_attachment_type_id: defaultAttachmentTypeId,
      attachments_path: attachmentsPath, skills_collection: skillsCollection, nested, errors, validate
    } = this.props

    if (name === 'attachment_relations') {
      return (
        <div>
          <input type='hidden' value={name} name='active_step' />
          {(errors !== undefined) &&
            <div className='alert alert-danger'>
              {`${I18n.t(`wizard_settings.steps.${name}`)} ${errors}`}
            </div>}
          {(settings.attachment_relations.custom_text !== undefined) &&
            <div className='mbottom20' dangerouslySetInnerHTML={{ __html: settings.attachment_relations.custom_text }} />}
          <DropzoneAttachments
            attachments={candidate.attachment_relations}
            param_name='attachment[file]'
            preview_template='#preview-template'
            default_type={defaultAttachmentTypeId.toString()}
            url={attachmentsPath}
          />
        </div>
      )
    } else if (name === 'photo') {
      const photoProps = photoAttributes
      photoProps.photo_url = candidate.photo.src
      photoProps.crop_attributes = candidate.photo_cropping_attributes
      photoProps.portal = true
      return (
        <div className='well p-4 text-center'>
          <input type='hidden' value={name} name='active_step' />
          <PhotoWithCropper {...photoProps} submit={validate} />
          <h4 className='mt-3'>{I18n.t('upload_user_photo')}</h4>
          <div className='small text-muted'>{I18n.t('user_photo_size_error')}</div>
        </div>
      )
    } else if (name === 'skills') {
      return (
        <div>
          <input type='hidden' value={name} name='active_step' />
          <SkillsTree tree={skillsCollection} id='skills' options={{ hideMain: true }} />
        </div>
      )
    } else if (nested) {
      return (
        <div>
          <input type='hidden' value={name} name='active_step' />
          <WizardNestedFields {...this.props} />
        </div>
      )
    } else {
      return (
        <div>
          <input type='hidden' value={name} name='active_step' />
          {this._renderFields()}
        </div>
      )
    }
  }

  _renderFields () {
    let fieldsOrder

    if (this.props.step === 1) {
      fieldsOrder = _.union(['salutation', 'first_name', 'last_name', 'email'], _.keys(this.props.fields))
    } else {
      fieldsOrder = _.keys(this.props.fields)
    }

    return fieldsOrder.map(name => {
      const field = this.props.fields[name]
      field.field = name
      field.jobAdId = this.props.job_ad_id

      if (field.immutable || JSON.parse(field.visible)) {
        if (this.props.name === 'qforms') {
          field.name = parseInt(name) ? `candidate[qforms_attributes][0][qform_field_values][${name}]` : `candidate[qforms_attributes][0][${name}]`
          field.value = (this.props.candidate.qforms && this.props.candidate.qforms[name]) || ''
          field.select_options_path = '/applications/fetch_options/qform_field?qform_field_id='
        } else if (field.type === 'address') {
          field.name = `candidate[address_attributes][${name}]`
          field.value = (this.props.candidate.address && this.props.candidate.address[name]) || ''
          field.select_options_path = '/applications/fetch_options/'
          field.values = this.props.candidate.address
          field.nestedInline = true
        } else {
          field.name = `candidate[${name}]`
          field.value = this.props.candidate[name] || ''
          field.select_options_path = '/applications/fetch_options/'
        }

        if (name === 'working_location') {
          field.value = this.props.candidate.working_location || null
          field.select_options_full_path = `/applications/fetch_options/working_location?job_ad_id=${field.jobAdId}`
        }

        if (name === 'channel_wizard') {
          field.value = this.props.candidate.channel
          this.props.candidate.channel === 'indeed' && (field.disabled = true)
        }

        if (field.type) {
          const FieldComponent = require(`components/form/${field.type}.js`).default
          return (
            <div key={field.field} className={`form-group ${INPUT_TYPE_MAP[field.type]} ${field.error ? 'has-error' : ''}`}>
              <span className='help-block'>{field.error}</span>
              <label
                id={`${name}_label`}
                className={cn('control-label', `${INPUT_TYPE_MAP[field.type]}`, { 'd-none': name === 'working_location' })}
              >
                {field.label || I18n.t(`wizard_settings.${this.props.name}.${name}`)}
                {(field.required || field.immutable) &&
                  <abbr title='required' className='mleft5'>*</abbr>}
              </label>
              <FieldComponent {...field} labelRef={this.labelRef} />
            </div>
          )
        }
      }
      return null // do not render disabled fields
    })
  }
}

WizardStep.propTypes = {
  name: PropTypes.string.isRequired,
  fields: PropTypes.object
  // value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}
